import React from "react";
import { StepperInput } from "@toddle-edu/ds-web";

const styles = {
  defaultWidth: { width: "232px" },
};

export const Stepper = props => {
  return (
    <StepperInput {...props} style={styles.defaultWidth} placeholder="0" />
  );
};

export default Stepper;
